<template>
  <div class="keyword-tags" :class="itemClassName">
    <div  id="input-group-skills-tagsinput">
      <input class="form-control" :id="itemClassName +'input-search'" type="text" value=""  :placeholder="placeholder" data-role="tagsinput" v-model="query" autocomplete="off"/>
    </div>
    <typeahead v-model="queryWiki" :target="'.' +itemClassName+ ' #input-group-skills-tagsinput input'" class="inputSearchTypeahead" :async-function="getSearchWiki" ></typeahead>
  </div>

</template>

<style>
  .keyword-tags .bootstrap-tagsinput .btn { border-radius: 4px;  padding: 3px 6px; margin: 3px; max-width: 300px; }
  #input-group-skills-tagsinput .bootstrap-tagsinput { width: 100%}
  #input-group-skills-tagsinput .bootstrap-tagsinput input {min-width: 260px;}
</style>
<script>
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.css'
import Tagsinput from '@adactive/bootstrap-tagsinput'

export default {
  components: {
    Tagsinput
  },
  name: 'KeywordBox',
  props: ['value', 'placeholder', 'itemClassName'],
  watch: {
    value: function (value) {
      this.query = value
      this.queryToTags()
    }
  },
  data () {
    return {
      query: '',
      urlWiki: 'https://en.wikipedia.org/w/api.php',
      queryWiki: ''
    }
  },
  methods: {
    getQuery: function () {
      return this.query
    },
    emitQuery: function () {
      this.$emit('input', this.query)
    },
    getSearchWiki: function (query, done) {
      let queryTmp = query.match(/"[\w\s]+"|\w+/gm)
      let queryToSearch = ''
      if (query.length > 3 && queryTmp !== null && queryTmp !== '') {
        queryToSearch = query
        $.ajax({
          dataType: 'json',
          url: this.urlWiki + '?origin=*&action=opensearch&search=' + queryToSearch.trim() + '&limit=5&namespace=0&format=json&callback=?',
          cache: true
        }).then((response) => {
          let resp = response[1].indexOf(queryToSearch) !== -1 ? response[1] : [queryToSearch, ...response[1]]
          done(resp)
        }).catch((error) => {

        })
      }
    },
    queryToTags: function () {
      $('#' + this.itemClassName + 'input-search').tagsinput('removeAll')
      if (this.query !== null && this.query.length) {
        let query = this.query.split(',')
        query.forEach((tag) => {
          $('#' + this.itemClassName + 'input-search').tagsinput('add', tag)
        })
        this.parseLogicWord()
      }
    },
    parseLogicWord: function () {
      $('.' + this.itemClassName + ' .tag').map(function (key, tag) {
        tag = $(tag)
        let text = $(tag).text().trim()
        if (text === 'AND' || text === 'OR' || text === 'NOT') {
          tag.removeClass('btn btn-info')
          tag.addClass('logic-word')
        }
      })
    },
    resizeTagsinpt: function () {
      let tagsinput = $('.' + this.itemClassName + ' #input-group-skills-tagsinput input').first()
      if ($('.' + this.itemClassName + ' .tag').length === 1) {
        tagsinput.attr('placeholder', '')
        tagsinput.css('width', '200px')
      } else if ($('.' + this.itemClassName + ' .tag').length === 0) {
        tagsinput.css('width', '100%')
        tagsinput.attr('placeholder', this.placeholder)
      }
    }
  },
  beforeMount () {
    this.query = this.value
  },
  mounted () {
    $('#' + this.itemClassName + 'input-search').tagsinput({
      tagClass: 'btn btn-info',
      allowDuplicates: false,
      trimValue: true,
      // cancelConfirmKeysOnEmpty: true,
      maxChars: 35
    })

    $('.inputSearchTypeahead').on('click', (e, datum) => {
      if ($('.inputSearchTypeahead li span').first().length !== 0) {
        let keywToDeleted = $('.inputSearchTypeahead li span').first()[0].innerText
      }
      let keyToAdded = e.toElement.parentElement.textContent
      if (keyToAdded && e.target.tagName !== 'UL') {
        if (typeof keywToDeleted !== 'undefined') {
          $('#' + this.itemClassName + 'input-search').tagsinput('remove', keywToDeleted)
        }
        $('#' + this.itemClassName + 'input-search').tagsinput('add', keyToAdded)
      }
      this.queryWiki = ''
    })

    $('.inputSearchTypeahead').mousedown(function (e) {
      e.preventDefault()
    })

    $('#' + this.itemClassName + 'input-search').on('itemAdded', (event) => {
      this.parseLogicWord()
      this.query = $('#' + this.itemClassName + 'input-search').val()
      this.emitQuery()
      this.resizeTagsinpt()
    })

    $('#' + this.itemClassName + 'input-search').on('itemRemoved', (event) => {
      this.parseLogicWord()
      this.query = $('#' + this.itemClassName + 'input-search').val()
      this.resizeTagsinpt()
      this.$emit('input', this.query)
    })

    $('.bootstrap-tagsinput input').on('keypress', (event) => {
      if (event.keyCode === 13) {
        if (this.query && event.target.value === '') {
          this.submitSearch(null)
        }
      }
    })
    this.queryToTags()
    this.parseLogicWord()
    this.resizeTagsinpt()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/KeywordBox.vue